import { AfterViewInit, Component, ElementRef, Input, OnDestroy } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { BrowserPopupService } from '../../../services/ui/browser-popup.service';

@Component({
  selector: 'app-user-html',
  templateUrl: './user-html.component.html',
  styleUrls: ['./user-html.component.scss']
})
export class UserHtmlComponent implements AfterViewInit, OnDestroy {
  @Input() public content: string;
  @Input() public raw: boolean | string = false;

  public get isRaw(): boolean {
    return this.raw === true || this.raw === '' || this.raw === 'true';
  }

  private anchorClickListener: (event: Event) => void;

  constructor(
    private element: ElementRef<HTMLElement>,
    private alertController: AlertController,
    private translateService: TranslateService,
    private browserPopupService: BrowserPopupService
  ) {
  }

  public ngAfterViewInit(): void {
    this.anchorClickListener = (event: Event) => this.openExternalLinkWithConfirmation(event);
    this.element.nativeElement.addEventListener('click', this.anchorClickListener);
  }

  public ngOnDestroy(): void {
    if (this.anchorClickListener) {
      this.element.nativeElement.removeEventListener('click', this.anchorClickListener);
    }
  }

  private openExternalLinkWithConfirmation(event: Event): void {
    const anchor = this.findExternalLinkAnchor(event.target);
    const url = anchor?.dataset?.href;

    if (!url) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    this.alertController.create({
      header: this.translateService.instant('GENERAL.EXTERNAL_LINK_ALERT.MESSAGE'),
      message: url,
      buttons: [
        {
          text: this.translateService.instant('GENERAL.EXTERNAL_LINK_ALERT.CANCEL'),
          handler: () => {
          }
        },
        {
          text: this.translateService.instant('GENERAL.EXTERNAL_LINK_ALERT.CONFIRM'),
          handler: () => {
            this.browserPopupService.open(url);
          }
        }
      ]
    }).then((popup) => popup.present());
  }

  private findExternalLinkAnchor(target: EventTarget): HTMLAnchorElement {
    if (!(target instanceof HTMLElement)) {
      return null;
    }

    return target.closest('a[data-href]');
  }
}
